import { Schemas } from '@api-client/generated/types';

type EventType = Schemas.MembershipEventRecordDto['type'];
type Channel = Schemas.MembershipEventRecordDto['channel'];
type Actor = Schemas.MembershipEventActorDto | null;

export type EventTone = 'granted' | 'revoked' | 'changed';

/** Human-readable action for a membership event. The journal only emits
 * created/updated/deleted; other event types fall back to a neutral label. */
export const eventAction = (
  type: EventType
): { label: string; tone: EventTone } => {
  switch (type) {
    case 'created':
      return { label: 'Access granted', tone: 'granted' };
    case 'deleted':
      return { label: 'Access revoked', tone: 'revoked' };
    case 'updated':
      return { label: 'Permissions changed', tone: 'changed' };
    default:
      return { label: 'Access updated', tone: 'changed' };
  }
};

/** The action channel — deliberately distinct from the actor's identity/type. */
export const channelLabel = (channel: Channel): string =>
  channel === 'backoffice' ? 'Backoffice' : 'Client portal';

export const actorName = (actor: Actor): string => {
  if (!actor) return 'Unknown';
  const name = `${actor.firstName} ${actor.lastName}`.trim();
  return name || actor.email;
};
